var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('a',_vm._g(_vm._b({staticClass:"blue-link nq-link"},'a',_vm.$attrs,false),_vm.$listeners),[_vm._t("default"),_c('ArrowRightSmallIcon')],2)}
var staticRenderFns = []

export { render, staticRenderFns }